import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FOOTER_ICON_COLOR } from "styles/colors";

const Footer = () => {
  return (
    <Box py={1.5} display="flex" justifyContent="space-between" color="#707070">
      <Typography
        sx={{ fontSize: { lg: "1rem", xl: "1.5rem" } }}
        px="5px"
        lineHeight={1.21}
      >
        COPYRIGHT © 2023 GoFinance. All rights reserved
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          sx={{ fontSize: { lg: "1rem", xl: "1.5rem" } }}
          px="5px"
          lineHeight={1.21}
        >
          Project By YallaBid
        </Typography>
        <FavoriteBorderIcon sx={{ color: FOOTER_ICON_COLOR }} />
      </Box>
    </Box>
  );
};

export default Footer;
